export default __webpack_public_path__ + "static/di.harald.schneider-4d4424a7c593524a6c855c737ca106a9.webp";